module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./DeliveryView.js"));
	}, "DeliveryView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=DeliveryView!./src/pages/Shop/Member/TradeManage/OrderList/Detail/Delivery/DeliveryView.js
// module id = 1035
// module chunks = 431